import type React from 'react'

interface Props {
  landlordName: string
  isLandlordDifferent: boolean
}

const Confirmation: React.FC<Props> = ({ landlordName, isLandlordDifferent }) => {
  return (
    <div>
      {isLandlordDifferent ? (
        <p>Please remove the current landlord before updating this address.</p>
      ) : (
        <p>
          Is <strong>{landlordName}</strong> still the correct landlord for this address?
        </p>
      )}
    </div>
  )
}

export default Confirmation
